import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { TagService } from '~/app/features/feed/feed-tag/service/tag.service';
import { AuthService } from '../auth/services/authentication.service';
import { LayoutService } from '../services/store/layout.service';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-bottom-navs',
  templateUrl: './bottom-navs.component.html',
  imports: [RouterLink, RouterLinkActive, TranslateModule],
})
export class BottomNavsComponent implements OnInit, OnDestroy {
  public isLoggedIn = false;
  public hasAnySubscriptions = false;

  private authSubscription?: Subscription;
  public subscriptionsUpdatedSubscription?: Subscription;

  public authService = inject(AuthService);
  private tagService = inject(TagService);
  private layoutService = inject(LayoutService);

  public ngOnInit() {
    this.subscriptionsUpdatedSubscription = this.layoutService.subscriptionsUpdated.subscribe(() => {
      this.checkSubscriptions();
    });
  }

  private checkSubscriptions() {
    this.authSubscription = this.authService
      .isLoggedIn()
      .pipe(distinctUntilChanged())
      .subscribe((isLoggedIn) => {
        this.isLoggedIn = isLoggedIn;

        if (this.isLoggedIn) {
          this.tagService.getFeedSubscription().subscribe((result) => {
            this.hasAnySubscriptions = result.length > 0;
          });
        } else {
          this.hasAnySubscriptions = false;
        }
      });
  }

  public ngOnDestroy(): void {
    this.authSubscription?.unsubscribe();
    this.subscriptionsUpdatedSubscription?.unsubscribe();
  }
}
